// extracted by mini-css-extract-plugin
export default {"container":"ModalCard_container__CXzJm","header":"ModalCard_header__1aNvz","title":"ModalCard_title__uwHdN","description":"ModalCard_description__TvA5L"};